import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type TeamHeidiIiAccessUpdatedEventProps } from '@/models/analytics/features/team';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import {
  trackTeamCreatedSpec,
  trackTeamEvidenceAccessUpdatedSpec,
  trackTeamMemberAcceptedSpec,
  trackTeamMemberCreatedSpec,
  trackTeamMemberDeletedSpec,
  trackTeamUpdatedSpec,
  type TeamCreated,
  type TeamEvidenceAccessUpdated,
  type TeamMemberAccepted,
  type TeamMemberCreated,
  type TeamMemberDeleted,
  type TeamUpdated,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const teamEvents: SnowplowEventMap = {
  [TrackingEventName.TeamCreated]: (props) => trackTeamCreatedSpec(props as TeamCreated),
  [TrackingEventName.TeamUpdated]: (props) => trackTeamUpdatedSpec(props as TeamUpdated),
  [TrackingEventName.TeamMemberAccepted]: (props) =>
    trackTeamMemberAcceptedSpec(props as TeamMemberAccepted),
  [TrackingEventName.TeamMemberCreated]: (props) =>
    trackTeamMemberCreatedSpec(props as TeamMemberCreated),
  [TrackingEventName.TeamMemberDeleted]: (props) =>
    trackTeamMemberDeletedSpec(props as TeamMemberDeleted),
  [TrackingEventName.TeamEvidenceAccessUpdated]: (props) =>
    trackTeamEvidenceAccessUpdatedSpec(props as TeamEvidenceAccessUpdated),
  // TODO(snowtype): swap to a generated Spec fn once Snowtype is regenerated
  // against the published team_heidi_ii_access_updated schema.
  [TrackingEventName.TeamHeidiIiAccessUpdated]: (props) =>
    trackSelfDescribingEvent({
      event: {
        schema: 'iglu:com.heidi/team_heidi_ii_access_updated/jsonschema/1-0-1',
        data: props as TeamHeidiIiAccessUpdatedEventProps,
      },
    }),
};
